// @flow
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { fetchPageNode, resetPageNode } from 'actions/pageActions';
import PageMediaDetail from 'components/page/template/PageMediaDetail';
import type { StateProps, DispatchProps } from 'components/page/template/PageMediaDetail';
import type { StateType, DispatchType } from 'types/Actions';

import { fetchAlbum } from 'actions/albumActions';

const mapStateToProps = (state: StateType): StateProps => ({
  album: state.albumState.album,
  albumStatus: state.albumState.albumStatus,
  sidebar: state.pageListState.sidebar_content,
  slug_parent: state.pageNodeState.pageNode.slug_parent,
  titleParent: state.pageNodeState.pageNode.titleParent
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchProps => ({
  fetchAlbum: (slug: string, args: string) => dispatch(fetchAlbum(slug, args)),
  fetchPageNode: (slug: string) => dispatch(fetchPageNode(slug)),
  resetPageNode: () => dispatch(resetPageNode())
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PageMediaDetail));
